import React from 'react';
import Notification from '@tds/core-notification';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const SuccessIot = () => {
  const {
    contractSignatureIOT: { successPage }
  } = useLocalizedStringsContext();

  return (
    <>
      <div className="container 85%" style={{ minHeight: '600px' }}>
        <Notification variant="branded" copy="en">
          {successPage}
        </Notification>
      </div>
    </>
  );
};

export default SuccessIot;
